import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';

import Select from 'components/ui/SelectField';
import { LEASE, FIXED_ADDENDUM, CONDITIONAL_ADDENDUM } from '../../CreateDocumentTemplateDialog';

const StyledSelect = styled(Select)`
  width: 100%;
`;

const StyledLabel = styled.label`
  margin-top: 10px;
`;

const StyledError = styled.div`
  color: red;
  margin-top: 5px;
`;


const DocumentType = ({ values, errors, touched, setFieldValue }) => {
  const document_types = [
    {
      value: LEASE,
      label: getTranslatedString('landlordPortal.documentTemplate.setupPage.lease'),
    },
    {
      value: FIXED_ADDENDUM,
      label: getTranslatedString('landlordPortal.documentTemplate.setupPage.addendumFixed'),
    },
    {
      value: CONDITIONAL_ADDENDUM,
      label: getTranslatedString('landlordPortal.documentTemplate.setupPage.addendumConditional'),
    },
  ];

  return (
    <React.Fragment>
      <StyledLabel>
        {getTranslatedString('landlordPortal.documentTemplate.selectDocumentType')}
      </StyledLabel>
      <StyledSelect
        name="signable_doc_type"
        showSearch
        placeholder={getTranslatedString('landlordPortal.documentTemplate.selectDocumentType')}
        size="large"
        value={values.signable_doc_type}
        onChange={(value) => setFieldValue('signable_doc_type', value)}
      >
        {document_types.map((document_type) => (
          <Select.Option value={document_type.value} key={`${document_type.value}`}>
            {document_type.label}
          </Select.Option>
        ))}
      </StyledSelect>
      {errors.signable_doc_type && touched.signable_doc_type ? (
        <StyledError>{errors.signable_doc_type}</StyledError>
      ) : null}
    </React.Fragment>
  );
};

export default DocumentType;
